import React from 'react';
import { ButtonTemplateProps } from '..';
import { TranslationKey } from '../../../../types/translation/TranslationKey';
import { t } from '../../../../types/translation/Translator';
import { IconButton } from '../../../icons';
import { IconType } from '../../../icons/Icon';

export default function ExportIconButton(props: ButtonTemplateProps) {
  return <IconButton {...props} text={props.text || t(TranslationKey.export).singular.upper} type={IconType.upload1} />;
}
